<template>
  <div id="app">
    <el-container>
      <el-header>
        <el-main><h2>Ожидайте подтверждения записи билета.</h2>
        <h2>В случае ошибки записи, деньги за билет будут возвращены.</h2></el-main>
      </el-header>
    </el-container>
    <el-row type="flex" justify="center" id="mainForm">
      <el-col :xs="22" :sm="16" :md="14" :lg="12" :xl="8">
<!--        <el-card shadow="always" class="text-center one-control">-->
<!--        </el-card>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios"
export default {
  computed: {},
  data(){
    return {
      API_LOCATION: process.env.API_LOCATION
    };
  },
  created(){

    var getTxnStatus = () => {
      const transactionId = localStorage.getItem("transaction_id") || sessionStorage.getItem("transaction_id");
      const cardNumber = localStorage.getItem("card_number") || sessionStorage.getItem("card_number");

      const post = {
        transaction_id: transactionId,
        card_number: cardNumber
      };

      axios
        .post(this.API_LOCATION + "/status", post)
        .then(response => {
          if (response.data.status === "success") {
            window.location.href = "#/success";
          } else {
            if (response.data.status === "wait") {
              window.setTimeout(getTxnStatus, 1000);
            } else {
              window.location.href = "#/error";
            }
          }
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error_code
          ) {
            //console.log("Error in txn status get");
          }

          window.location.href = "#/error";
        });
    };

    window.setTimeout(getTxnStatus, 1000);
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/finishAwait.vue